import React from 'react';
import { fontSizes } from '../../constants/constants';
import Text from '../Text';
import textWeight from '../../utils/textWeight';
import { ReactSVG } from 'react-svg';

const ProjectTrackingCom = (props) => {
  const { TextWeight } = textWeight();
  const getStatusStyles = (status) => {
    const normalized = status
      ? status.replace(/_/g, ' ').trim()
      : '';

    if (!normalized) {
      return {
        label: '-',
        color: 'text-gray-400',
        className:
          'inline-flex self-center items-center justify-center px-3 py-[6px] leading-tight text-center box-border min-w-[72px] sm:min-w-[88px] max-w-[120px]',
      };
    }

    const upperLabel = normalized.toUpperCase();

    const statusMap = {
      COMPLETED: {
        color: 'text-[#00D223]',
        border: 'border border-[#00D223]',
      },
      FAILED: {
        color: 'text-[#F5430B]',
        border: 'border border-[#F5430B]',
      },
      'IN PROGRESS': {
        color: 'text-[#DF9426]',
        border: 'border border-[#DF9426]',
      },
    };

    const resolvedStyles =
      statusMap[upperLabel] ||
      {
        color: 'text-[#2563EB]',
        border: 'border border-[#2563EB]',
      };

    return {
      label: upperLabel,
      color: resolvedStyles.color,
      className: `${resolvedStyles.border} rounded-full px-3 py-[6px] leading-tight min-w-[72px] sm:min-w-[88px] max-w-[120px] inline-flex self-center items-center justify-center text-center box-border whitespace-nowrap`,
    };
  };

  const quantityStatusStyles = getStatusStyles(props.quantityStatus);
  const materialStatusStyles = getStatusStyles(props.materialReportStatus);
  const costStatusStyles = getStatusStyles(props.costingReportStatus);

  return (
    <div
      className={`shadow-custom-gray ${props.cursorClassName} px-6 py-6 rounded-[30px] bg-white flex flex-col justify-between gap-4 h-full transition-all duration-200 hover:-translate-y-[2px] hover:shadow-xl`}
   >
      <div className='flex items-center gap-3'>
        <div
          className={`w-7 h-7 rounded-full`}
          style={{ backgroundColor: props.projectColor }}
        ></div>
        <Text
          text={props.ProjectName}
          size={fontSizes.h24}
          weight={TextWeight.Raleway_Bold}
          color='text-black'
          isTruncate={false}
          className='leading-tight'
        />
      </div>
      <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 flex-1'>
        <div className='rounded-2xl border border-[#E5E7EB] bg-[#F9FAFB] px-4 sm:px-5 py-3 flex flex-col items-center gap-2 w-full'>
          <div className='flex items-center justify-center gap-2'>
            <Text
              text={'Quantity'}
              size={fontSizes.h16}
              weight={TextWeight.Raleway_SemiBold}
              color='text-[#111827]'
              isTruncate={false}
              className='uppercase tracking-wide text-center'
            />
            {props.isQuantityReportVerified && (
              <ReactSVG src={props.StatusCheckIcons} />
            )}
          </div>
          <div className='w-full flex justify-center'>
            <Text
              text={quantityStatusStyles.label}
              size={fontSizes.h11}
              weight={TextWeight.Raleway_Medium}
              color={quantityStatusStyles.color}
              isTruncate={false}
              className={quantityStatusStyles.className}
            />
          </div>
        </div>
        <div className='rounded-2xl border border-[#E5E7EB] bg-[#F9FAFB] px-4 sm:px-5 py-3 flex flex-col items-center gap-2 w-full'>
          <div className='flex items-center justify-center gap-2'>
            <Text
              text={'Material'}
              size={fontSizes.h16}
              weight={TextWeight.Raleway_SemiBold}
              color='text-[#111827]'
              isTruncate={false}
              className='uppercase tracking-wide text-center'
            />
            {props.isMaterialReportVerified && (
              <ReactSVG src={props.StatusCheckIcons} />
            )}
          </div>
          <div className='w-full flex justify-center'>
            <Text
              text={materialStatusStyles.label}
              size={fontSizes.h11}
              weight={TextWeight.Raleway_Medium}
              color={materialStatusStyles.color}
              isTruncate={false}
              className={materialStatusStyles.className}
            />
          </div>
        </div>
        <div className='rounded-2xl border border-[#E5E7EB] bg-[#F9FAFB] px-4 sm:px-5 py-3 flex flex-col items-center gap-2 w-full'>
          <div className='flex items-center justify-center gap-2'>
            <Text
              text={'Cost'}
              size={fontSizes.h16}
              weight={TextWeight.Raleway_SemiBold}
              color='text-[#111827]'
              isTruncate={false}
              className='uppercase tracking-wide text-center'
            />
            {props.isCostingReportVerified && (
              <ReactSVG src={props.StatusCheckIcons} />
            )}
          </div>

          <div className='w-full flex justify-center'>
            <Text
              text={costStatusStyles.label}
              size={fontSizes.h11}
              weight={TextWeight.Raleway_Medium}
              color={costStatusStyles.color}
              isTruncate={false}
              className={costStatusStyles.className}
            />
          </div>
        </div>
      </div>
      <div className='border-t border-[#E5E7EB] pt-3 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between sm:gap-5'>
        <div className='flex flex-col gap-1 w-full sm:w-1/2'>
          <Text
            text={'Service'}
            size={fontSizes.h13}
            weight={TextWeight.Raleway_Medium}
            color='text-gray-500'
            isTruncate={false}
            className='uppercase tracking-wide'
          />
          <Text
            text={props?.serviceName || '-'}
            size={fontSizes.h15}
            weight={TextWeight.Raleway_SemiBold}
            color='text-black'
            isTruncate={false}
            className='whitespace-normal leading-snug'
          />
        </div>
        <div className='flex flex-col gap-1 w-full sm:w-1/2 sm:items-end'>
          <Text
            text={'Date Created'}
            size={fontSizes.h13}
            weight={TextWeight.Raleway_Medium}
            color='text-gray-500'
            isTruncate={false}
            className='uppercase tracking-wide sm:text-right'
          />
          <Text
            text={props.projectDate || '-'}
            size={fontSizes.h15}
            weight={TextWeight.Raleway_SemiBold}
            color='text-black'
            isTruncate={false}
            className='whitespace-normal leading-snug sm:text-right'
          />
        </div>
      </div>
    </div>
  );
};
export default ProjectTrackingCom;
